<template>
  <div>
    <form data-vv-scope="register">
      <div class="form-wraper">
        <div class="number-prefix row m-0">
          <!-- Email input field and error -->
          <div class="col-12">
            <input
              v-validate="'required|email'"
              class="form-control login-signup-input mt-2"
              :class="(showSignUpError &&
                errors.has('register.email'))?'is-invalid':''"
              name="email"
              type="email"
              placeholder="Email"
              id="sign-up-email"
              data-ismobileonly="false"
              v-model="account.username"
              autocomplete="off"
														data-test="signUpFormEmailInput"
            >
            <div
              class="invalid-feedback"
              v-if="showSignUpError"
              v-show="errors.has('register.email')"
              id="sign-up-email-error"
														data-test="signUpFormEmailInputError"
            >
              {{errors.first('register.email')}}
            </div>
          </div>

          <!--Phone number Input field and error-->
          <!--v-if="(account.otpOption === 'phone')"?-->
          <div class="col-12">
            <input
              class="form-control login-signup-input mt-2"
              id="RegisterForm-phone-phone"
              type="text"
              name="phone"
              :class="(showSignUpError &&
                errors.has('register.phone'))?'is-invalid':''"
              v-model="account.phoneno"
              autocomplete="off"
              placeholder="Phone"
              v-validate="'required|min:10|max:10|numeric'"
              data-ismobileonly="false"
														data-test="signUpFormPhnInput"
            >
            <div
              class="invalid-feedback"
              v-if="showSignUpError"
              v-show="errors.has('register.phone')"
              id="RegisterForm-phone-phone-error"
														data-test="signUpFormPhnInputError"
            >
              {{errors.first('register.phone')}}
            </div>
          </div>
          <!--<div class="col-12" v-else>-->
          <!--<input class="form-control login-signup-input mt-2"-->
          <!--id="RegisterForm-phone-email"-->
          <!--type="text"-->
          <!--name="phone"-->
          <!--:class="(showSignUpError &&-->
          <!--errors.has('register.phone'))?'is-invalid':''"-->
          <!--v-model="account.phoneno"-->
          <!--autocomplete="off"-->
          <!--placeholder="Phone (Optional)"-->
          <!--v-validate="'min:10|numeric'"-->
          <!--data-ismobileonly="false"-->
          <!--&gt;-->
          <!--<div class="invalid-feedback"-->
          <!--v-if="showSignUpError"-->
          <!--v-show="errors.has('register.phone')"-->
          <!--id="RegisterForm-phone-email-error"-->
          <!--&gt;-->
          <!--{{errors.first('register.phone')}}-->
          <!--</div>-->
          <!--</div>-->
          <!-- Password Input field and error-->
          <div class="col-12">
            <input
              v-validate="'required|min:6'"
              :class="(showSignUpError &&
            errors.has('register.password'))?'is-invalid':''"
              class="form-control login-signup-input mt-2"
              data-ismobileonly="false"
              name="password"
              type="password"
              placeholder="Password"
              id="signup-password"
              v-model="account.password"
              autocomplete="off"
              ref="password"
														data-test="signUpFormPsswrdInput"
            >
            <div
              class="invalid-feedback"
              v-if="showSignUpError"
              v-show="errors.has('register.password')"
              id="signup-password-error"
														data-test="signUpFormPasswrdInputError"
            >
              {{errors.first('register.password')}}
            </div>
          </div>
          <!--Confirm Password Input field and error-->
          <div class="col-12">
            <input
              v-validate="'required|confirmed:password'"
              :class="(showSignUpError &&
                errors.has('register.confirmpassword'))?'is-invalid':''"
              class="form-control login-signup-input mt-2"
              name="confirmpassword"
              type="password"
              placeholder="Confirm Password"
              id="signup-confirm-password"
              autocomplete="off"
              v-model="account.confirmPassword"
              data-ismobileonly="false"
														data-test="signUpFormConfirmInput"
            >
            <div
              class="invalid-feedback"
              v-if="showSignUpError"
              v-show="errors.has('register.confirmpassword')"
              id="signup-confirm-password-error"
														data-test="signUpFormConfirmInputError"
            >
              The password confirmation does not match.
            </div>
          </div>
          <!--First Name Input field and error-->
          <div class="col-12">
            <input
              v-validate="'required|min:3|alpha'"
              type="text"
              :class="(showSignUpError &&
                errors.has('register.firstname'))?'is-invalid':''"
              class="form-control login-signup-input mt-2"
              name="firstname"
              placeholder="First Name"
              id="signup-firstname"
              v-model="account.firstname"
              autocomplete="off"
              data-ismobileonly="false"
														data-test="signUpFormFNInput"
            >
            <div
              class="invalid-feedback"
              v-if="showSignUpError"
              v-show="errors.has('register.firstname')"
              id="signup-firstname-error"
														data-test="signUpFormFNInputError"
            >
              {{errors.first('register.firstname')}}
            </div>
          </div>
          <!--Last Name Input field and error-->
          <div class="col-12">
            <input
              v-validate="'required|min:3|alpha'"
              type="text"
              :class="(showSignUpError &&
                errors.has('register.lastname'))?'is-invalid':''"
              class="form-control login-signup-input mt-2"
              name="lastname"
              placeholder="Last Name"
              id="signup-lastname"
              v-model="account.lastname"
              autocomplete="off"
              data-ismobileonly="false"
														data-test="signUpFormLNInput"
            >
            <div
              class="invalid-feedback"
              v-if="showSignUpError"
              v-show="errors.has('register.lastname')"
              id="signup-lastname-error"
														data-test="signUpFormLNInputError"
            >
              {{errors.first('register.lastname')}}
            </div>
          </div>
									<signup-vendor-promotion-form :showSignUpError="showSignUpError"
																																									:account="account"
																																									@updateVendorPromotionSignupData="setVendorPromotionSignupData($event)"
											/>

          <p
            class="address-type-p text-center mx-auto"
            id="verification-para"
												data-test="signUpFormPara1"
          >
            Choose Your Verification Method:
          </p>
          <div class="row text-center">
            <div class="col-md-6  col-6 ">
              <label
                class="input-container verification-method"
                id="signUp-sms-otp"
																data-test="signUpFormSMSLabel"
              >
                SMS OTP
                <input
                  class="ml-2"
                  type="radio"
                  value="phone"
                  id="signUp-sms-otp-radio"
                  name="verificationMethod"
                  v-model="account.otpOption"
																		data-test="signUpFormSMSInput"
                >
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="col-md-6 col-6">
              <label
                class="input-container verification-method"
                id="signUp-email-otp"
																data-test="signUpFormEmailOtpLabel"
              >
                Email OTP
                <input
                  class="ml-2"
                  type="radio"
                  value="email"
                  name="verificationMethod"
                  id="signUp-email-otp-radio"
                  v-model="account.otpOption"
																		data-test="signUpFormEmailOtpInput"
                >
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <!--<vue-recaptcha sitekey="6Lc4y4YUAAAAALegkESSMRqK2fiUfmBEQR4YH&#45;&#45;b">-->
        <!--</vue-recaptcha>-->
        <!--map-->
        <!--<div class="d-flex justify-content-center">-->
        <!--<input type="checkbox"-->
        <!--name="map"-->
        <!--style="display: none"-->
        <!--id="showMapButton-signUp-form"-->
        <!--@click.prevent="showMap === true?showMap = false:showMap = true"-->
        <!--&gt;-->
        <!--<label class="btn btn-link" style="text-decoration: none;"-->
        <!--for="showMapButton-signUp-form">-->
        <!--Show Map-->
        <!--</label>-->
        <!--</div>-->
        <!--<div class="leaflet-map-wrapper mb-2"-->
        <!--v-if="location.latitude !== 400"-->
        <!--&gt;-->
        <!--<div id="map" style="width:100%; height:358px"></div>-->
        <!--</div>-->
        <!--&lt;!&ndash;Available vendors&ndash;&gt;-->
        <!--<div class="input-group mb-3 px-3 d-flex align-items-center" v-if="vendorNameShow">-->
        <!--&lt;!&ndash;<label class="m-0">Available Vendors</label>&ndash;&gt;-->
        <!--<div class="w-100">-->
        <!--<select class="custom-select "-->
        <!--id="inputGroupSelect01"-->
        <!--name="mapselect"-->
        <!--style="color: #00008b;font-weight: 600;font-size:16px;"-->
        <!--@click="selectVendor"-->
        <!--&gt;-->
        <!--<option class="d-none">-->
        <!--Available Vendors-->
        <!--</option>-->
        <!--<option v-for="(vendor,index) in available_vendors"-->
        <!--:key="index"-->
        <!--:id="'vendor'+index"-->
        <!--:value="vendor.vendor_id"-->
        <!--&gt;-->
        <!--{{vendor.vendor_name}}-->
        <!--</option>-->
        <!--</select>-->

        <!--<small-->
        <!--style="color: #dc3545"-->
        <!--v-if="showSelectError"-->
        <!--id="vendor-RegisterForm-hostCountryName-error"-->
        <!--&gt;-->
        <!--Choose vendor...-->
        <!--</small>-->
        <!--</div>-->
        <!--</div>-->

        <small class="text-center d-block ">
          <input
            class="mr-2"
            name="checkbox"
            id="signUp-checkbox"
            type="checkbox"
            :class="(showSignUpError &&
              errors.has('register.checkbox'))?'is-invalid':''"
            v-model="account.checkbox"
            autocomplete="off"
            v-validate="'required'"
            checked=""
												data-test="signUpFormCheckInput"
          >
          By registering, I agree to
          <a
            href=""
            @click.prevent="terms"
            id="signUp-terms-condition-link"
												data-test="signUpFormLink1"
          >
            Terms & Conditions
          </a>
        </small>

      </div>

      <button
        class="btn col-12 btn-sm blue-btn continue-btn mt-2 mb-2"
        :disabled="!account.checkbox"
        v-loading="loading"
        @click.prevent="action('register')"
        id="signup-continue-btn"
								data-test="signUpFormBtn"
      >
        Continue
      </button>
      <!-- <a href=""
         @click.prevent="sellerLogin"
         style="text-align: center;display: block;"
      >
        Seller Login
      </a> -->
    </form>
  </div>
</template>
<script>
import { productApi as productApis } from '../../../../services/ApiServices/productApi'
import SignupVendorPromotionForm from '../widgets/SignupVendorPromotionForm'

export default {
	components: { SignupVendorPromotionForm },
	name: 'sign-up-form',
	props: {
		accountData: Object,
		loading: null
	},
	computed: {
		vendorPromotionFormError () {
			return (this.account.dob === '' && this.account.income_slab === 'Choose Your Income Range', this.account.occupation === 'Choose Your Occupation')
		}
	},
	mounted () {
		// this.getLocation();
		this.account = this.accountData
		this.account.income_slab = 'Choose Your Income Range'
		this.account.occupation = 'Choose Your Occupation'
		this.account.dob = ''
		this.$root.$on('SignUpFormClear', () => {
			//
			this.account = {
				firstname: '',
				lastname: '',
				username: '',
				password: '',
				phoneno: '',
				confirmPassword: '',
				checkbox: false,
				otpOption: 'phone',
				income_slab: 'Choose Your Income Range',
				occupation: 'Choose Your Occupation',
				dob: ''
			}
		})
	},
	data () {
		return {
			showMap: true,
			location: {
				latitude: 400,
				longitude: 400
			},
			selectedLocation: {},
			distance: 30000,
			locationList: [
				{
					latitude: 9.931233,
					longitude: 76.267303
				},
				{
					latitude: 9.783350,
					longitude: 76.542618
				},
				{
					latitude: 9.750869,
					longitude: 76.606448
				},
				{
					latitude: 9.690635,
					longitude: 76.667533
				},
				{
					latitude: 9.504450,
					longitude: 76.668954
				}
			],
			account: {
				checkbox: false
			},
			showSignUpError: false,
			vendorNameShow: false,
			showSelectError: false,
			showInvalidError: false,
			inputDateOfBirth: ''

		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					// if (result && this.selectedLocation.lat && this.showSelectError === false) {
					if (result && !this.vendorPromotionFormError) {
						this.showSignUpError = false
						this.$emit('signUpFormSubmit', this.account)
						// this.account = {
						//   otpOption: 'phone',
						//   checkbox: false,
						// };
					} else {
						// if (!this.selectedLocation.lat) {
						//   this.$toasted.show('Choose location');
						// }
						this.showSignUpError = true
						if (this.showInvalidError === false) {
							this.showSelectError = true
						}
					}
				})
		},
		setVendorPromotionSignupData (accountData) {
			this.account.income_slab = accountData.income_slab
			this.account.occupation = accountData.occupation
			this.account.dob = accountData.dob
		},
		selectVendor (event) {
			this.account.default_vendor = event.target.value
			if (this.account.default_vendor) {
				this.showSelectError = false
				this.showInvalidError = true
			}
		},
		getLocation () {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((loc) => {
					this.location = {
						latitude: loc.coords.latitude,
						longitude: loc.coords.longitude
					}
					setTimeout(() => {
						this.showMap = false
					}, 1000)
				})
			} else {
				alert('Geolocation is not supported by this browser.')
			}
		},
		terms () {
			$('#signin-modal')
				.modal('toggle')
			this.$router.push('/pages/terms')
		},
		getVendorNames () {
			productApis.getVendor(this.selectedLocation, this.distance)
				.then((res) => {
					this.showMap = false
					this.vendorNameShow = true

					this.available_vendors = res.data.available_vendors
				})
				.catch((e) => {

				})
		}
	},
	watch: {
		// location() {
		//   setTimeout(() => {
		//     // Creating map options
		//     const mapOptions = {
		//       center: [this.location.latitude, this.location.longitude],
		//       zoom: 10,
		//     };
		//     // Creating a map object
		//     const map = new L.map('map', mapOptions);
		//
		//     // Creating a Layer object
		//     const layer = new L.TileLayer('http://map.ecommerce.techgentsia.com/styles/osm-bright/{z}/{x}/{y}.png');
		//     // http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png
		//     // const layer = new L.TileLayer('http://192.168.2.29:8080/styles/osm-bright/{z}/{x}/{y}.png');
		//
		//     // Adding layer to the map
		//     map.addLayer(layer);
		//
		//     // Add Leaflet Marker
		//     // Icon options
		//     const iconOptions = {
		//       iconUrl: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
		//       iconSize: [38, 38],
		//     };
		//
		//     // Creating a custom icon
		//     const customIcon = L.icon(iconOptions);
		//     // Creating a marker
		//     const markerOptions = {
		//       title: 'MyLocation',
		//       clickable: true,
		//       draggable: true,
		//       icon: customIcon,
		//     };
		//
		//     // multiple markers creation to denote different bakkalas in a location
		//
		//     //   const marker = [];
		//     //   this.locationList.forEach((locationData, index) => {
		//     //
		//     //     marker[index] = L.marker([locationData.latitude, locationData.longitude], markerOptions);
		//     //     // Adding marker to the map
		//     //     marker[index].addTo(map).on('click', (e) => {
		//     //
		//     //     });
		//     //   });
		//     const marker = L.marker([this.location.latitude, this.location.longitude], markerOptions);
		//     // Adding marker to the map
		//     marker.addTo(map).on('click', (e) => {
		//       this.selectedLocation = e.latlng;
		//
		//     });
		//   }, 100);
		// },
		selectedLocation () {
			this.getVendorNames()
		}
	}
}
</script>
